var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c(
            "v-card-title",
            {
              staticClass: "d-block text-left pb-0"
            },
            [
              _c("h3", [_vm._v("Additional Information")]),
              _c("p", [_vm._v(_vm._s(_vm.question))])
            ]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "text-center pt-0"
            },
            [
              _vm.loading.reasons
                ? _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      width: "2",
                      size: "64",
                      color: "primary"
                    }
                  })
                : _c(
                    "div",
                    [
                      _c(
                        "v-radio-group",
                        {
                          model: {
                            value: _vm.reason,
                            callback: function callback($$v) {
                              _vm.reason = $$v
                            },
                            expression: "reason"
                          }
                        },
                        _vm._l(_vm.reasons, function(reason) {
                          return _c("v-radio", {
                            key: reason.id,
                            attrs: {
                              label: reason.name,
                              value: reason
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: "",
                    loading: _vm.loading.cancel
                  },
                  on: {
                    click: _vm.cancelCR
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    disabled: !_vm.reasonSelected,
                    loading: _vm.loading.requestOffer
                  },
                  on: {
                    click: _vm.requestOffer
                  }
                },
                [_vm._v(" Next ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("offer-modal", {
        attrs: {
          opened: _vm.dialog
        },
        on: {
          accepted: _vm.offerAccepted,
          declined: _vm.offerDeclined,
          close: function close($event) {
            _vm.dialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }